import { render, staticRenderFns } from "./LegosHQ.vue?vue&type=template&id=2f84d40f&scoped=true&"
import script from "./LegosHQ.vue?vue&type=script&lang=ts&"
export * from "./LegosHQ.vue?vue&type=script&lang=ts&"
import style0 from "./LegosHQ.vue?vue&type=style&index=0&id=2f84d40f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f84d40f",
  null
  
)

export default component.exports